module.exports = __webpack_public_path__ + "static/media/switch.3a0c76ad.png";